import api from "PFCore/api";
import { Conversation } from "PFTypes";

export const fetchConversation = (id: number): Promise<Conversation> =>
  api({
    url: `chat/conversations/${id}`
  });
